// extracted by mini-css-extract-plugin
export default {"root":"fullscreenaudio_root__ndcbW","container":"fullscreenaudio_container__6fnct","audio":"fullscreenaudio_audio__+hFh7","btn":"fullscreenaudio_btn__ZHbr7"};